var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Datetime from '../datetime';
import Icon from '../icon';
import Loader from '../loader';
import Thumbnail from '../thumbnail';
import { Styled } from './style';
export var CastItemAction;
(function (CastItemAction) {
    CastItemAction["Navigate"] = "navigate";
    CastItemAction["Stop"] = "stop";
})(CastItemAction || (CastItemAction = {}));
var CastItem = /** @class */ (function (_super) {
    __extends(CastItem, _super);
    function CastItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isStopping: false,
        };
        _this.getDateTimeFormat = function (dateTime) { return format(new Date(dateTime), 'dd MMM YYYY H:mm a'); };
        _this.getDurationFormat = function (seconds) {
            var date = new Date(0);
            date.setSeconds(seconds);
            return date.toISOString().substr(14, 5);
        };
        _this.handleCastStop = function (event) {
            _this.props.onCallback(CastItemAction.Stop, { id: _this.props.itemId, name: _this.props.contentName });
            _this.setState({
                isStopping: true,
            });
        };
        _this.handleLinkClick = function (event) {
            _this.props.onCallback(CastItemAction.Navigate, { id: _this.props.itemId, name: _this.props.contentName });
        };
        return _this;
    }
    CastItem.prototype.render = function () {
        return (React.createElement(Styled, { className: "cast-item" },
            React.createElement("div", { className: "media-core", onClick: this.handleLinkClick },
                React.createElement("div", { className: "media-alpha" },
                    this.props.mimeType !== 'playlist' ? (React.createElement("div", { className: "thumbnail-preview" },
                        React.createElement(Thumbnail, { size: "medium", src: this.props.contentImage ? this.props.contentImage : '' }))) : (React.createElement("div", { className: "thumbnail-preview", style: { backgroundColor: this.props.color }, onClick: this.handleLinkClick },
                        React.createElement("div", { className: "thumbnail" },
                            React.createElement("div", { className: "wrapper" },
                                React.createElement(Icon, { name: "playlist" }))))),
                    React.createElement("div", { className: "media-title" },
                        React.createElement("h3", { title: this.props.contentName },
                            React.createElement("span", null, this.props.contentName)),
                        isValid(parseISO(this.props.castDate)) && (React.createElement(FormattedMessage, { id: "ui_component.cast_item.recent_casted_on_date", defaultMessage: "Casting since {castDate}", values: { castDate: React.createElement(Datetime, { value: this.props.castDate }) } })),
                        React.createElement("span", { className: "meta-responsive" },
                            this.props.mimeType,
                            " ",
                            this.props.duration ? " \u00B7 " + this.getDurationFormat(this.props.duration) : ''))),
                React.createElement("div", { className: "media-duration" },
                    React.createElement("span", null, this.props.duration && this.getDurationFormat(this.props.duration))),
                React.createElement("div", { className: "media-kind" },
                    React.createElement("span", null, this.props.mimeType)),
                React.createElement("div", { className: "media-screens" },
                    React.createElement("span", null,
                        React.createElement(Icon, { name: "screen-casting" }),
                        React.createElement("span", { className: "screen-count" }, this.props.screenCount)))),
            React.createElement("div", { className: "media-action" }, !this.state.isStopping ? (React.createElement("div", { title: "Stop casting", className: "screen-stop", onClick: this.handleCastStop },
                React.createElement(Icon, { name: "stop" }))) : (React.createElement("div", { title: "stopping", className: "screen-pending" },
                React.createElement(Loader, { inline: true, active: true, size: "mini" }))))));
    };
    return CastItem;
}(React.PureComponent));
export default CastItem;
//# sourceMappingURL=index.js.map